

export class OpportunityOperationWorkstationModel {
    operationId: string;
    operationDesc: string;
    operatorName: string;
    actualSpentTimePerGmt: number[];
    workstationCode: string;
    workstationDesc: string;


    constructor(operationId: string,
        operationDesc: string,
        operatorName: string,        
        actualSpentTimePerGmt: number[],
        workstationCode: string,
        workstationDesc: string) {
            this.operationId = operationId;
            this.operationDesc = operationDesc;
            this.operatorName = operatorName;
            this.actualSpentTimePerGmt = actualSpentTimePerGmt;
            this.workstationCode = workstationCode;
            this.workstationDesc = workstationDesc;
    }
}
